import { render, staticRenderFns } from "./TokenRedirect.vue?vue&type=template&id=d116dede&scoped=true"
import script from "./TokenRedirect.vue?vue&type=script&lang=js"
export * from "./TokenRedirect.vue?vue&type=script&lang=js"
import style0 from "./TokenRedirect.vue?vue&type=style&index=0&id=d116dede&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d116dede",
  null
  
)

export default component.exports